<div class="ad-container" [style.width.px]="viewWidth" [style.height.px]="viewHeight">
  @if (type.type === 'banner') {
  <AMore-sdk-ad-img-view (onChangeEvent)="changeAction($event)" [adData]="adData"
    [index]="type.index"></AMore-sdk-ad-img-view>

  }
  @if (type.type === 'video') {
  <AMore-sdk-ad-video-view (onChangeEvent)="changeAction($event)" [adData]="adData"
    [index]="type.index"></AMore-sdk-ad-video-view>
  }
  @if (type.type === 'rich_media') {
  <AMore-sdk-ad-media-view (onChangeEvent)="changeAction($event)" [adData]="adData"
    [index]="type.index"></AMore-sdk-ad-media-view>
  }
</div>


<button hidden (click)="rotate(90)" id="rotate-right-button"></button>
<button hidden (click)="rotate(-90)" id="rotate-left-button"></button>
<button hidden (click)="rotate(0)" id="rotate-center-button"></button>